export const extractYouTubeIds = (urls: string[]): string[] => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;

  return urls.reduce<string[]>((ids, url) => {
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      ids.push(match[2]);
    }
    return ids;
  }, []);
};
